import { render } from "./attrType.vue?vue&type=template&id=05af4017"
import script from "./attrType.vue?vue&type=script&lang=js"
export * from "./attrType.vue?vue&type=script&lang=js"

import exportComponent from "/var/lib/jenkins/workspace/test-event-admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/brandProduct/components/attrType.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "05af4017"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('05af4017', __exports__)) {
    console.log('reload')
    api.reload('05af4017', __exports__)
  }
  
  module.hot.accept("./attrType.vue?vue&type=template&id=05af4017", () => {
    console.log('re-render')
    api.rerender('05af4017', render)
  })

}


export default __exports__